import { render } from "./SkeletonCredential.vue?vue&type=template&id=e06246fc"
import script from "./SkeletonCredential.vue?vue&type=script&lang=js"
export * from "./SkeletonCredential.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__